import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query'
import { runCode, RunCodeResponse } from '@/features/code-runner'

const InitialResults: RunCodeResponse = {
  messages: [],
  executionTime: 0,
}

export const codeRunnerQueries = {
  all: () => ['code-runner'],
  lists: () => [...codeRunnerQueries.all(), 'list'],
  list: (id: string) =>
    queryOptions({
      queryKey: [...codeRunnerQueries.all(), 'list', { id }],
      queryFn: () => Promise.resolve(InitialResults),
      initialData: InitialResults,
      staleTime: Infinity,
    }),
}

export const useRunCode = (id: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['useRunCode'],
    mutationFn: runCode,
    onSuccess: (data) => {
      queryClient.setQueryData(codeRunnerQueries.list(id).queryKey, data)
    },
  })
}
